import React, {Component, Fragment} from "react";
import {Graphics, Text, withPixiApp} from "@inlet/react-pixi";
import withAutoplayConfiguration from "./configuration/withAutoplayConfiguration";

import * as PIXI from "pixi.js";
import UIManager from "./../ui/UiBuilder";
import {connect} from "react-redux";
import {IStore} from "../../store/IStore";
import {Dispatch} from "redux";
import Image from 'react-bootstrap/Image'


import {actions as baseGameActions, actions as basegameActions} from "../../reducers/baseGameReducer";
import {actions as freegameActions} from "../../reducers/freeGameReducer";
import withBaseGameConfiguration from "../basegame/configuration/withBaseGameConfiguration";
import {actions as winpresentationAction} from "../../reducers/winPresentationReducer";
import {Container, Button, ButtonToolbar, ButtonGroup, Alert} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import {ParticleUtils} from "pixi-particles";
import {MDBBtn, MDBCol, MDBIcon, MDBTable, MDBTableBody, MDBContainer, MDBRow} from "mdbreact";

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import {isMobile} from "react-device-detect";
import {actions as buttonActions} from "../../reducers/buttonPanelReducer";
import {actions as autoplayActions} from "../../reducers/autoplayReducer";
import {actions as asyncActions} from "../../reducers/asyncServerResponseReducer";


interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IState {
    isGameLoaded: boolean,
    enableOk: boolean,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    buttonSelected: any,
    selectedautoplayCount: number,
    toggleOn: boolean,

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class Autoplay extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected autoplayContainer: any;
    protected scope: any;
    protected showFixedPanelPage: boolean;
    protected outerBorderColor: any;
    protected textColor: any;
    protected colorOfButtonsWithoutCLick: any;
    protected colorOfButtonsOnCLick: any;
    protected mainContainerBgColor: any;
    protected partitioningLineBorderColor: any;
    protected clickedNumberButton: any;
    protected unclickedNumberButton: any;
    protected startbutton: any;
    protected enableAutoplayStartButtonX: number;
    protected enableAutoplayStartButtonY: number;
    protected disableAutoplayStartButtonX: number;
    protected disableAutoplayStartButtonY: number;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.autoplayContainer = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            buttonSelected: "",
            selectedautoplayCount: 0,
            pixelRatio: 1,
            enableOk: false,
            isGameLoaded: false,
            toggleOn: true

        }
        this.showFixedPanelPage = false
        this.outerBorderColor = '#FFFFFF'
        this.textColor = '#f5f3ec'
        this.colorOfButtonsWithoutCLick = '#808080'
        this.colorOfButtonsOnCLick = '#008000'
        this.mainContainerBgColor = 'transparent'
        this.partitioningLineBorderColor = '#808080'
        this.clickedNumberButton = this.props.data.clickedNumberButton
        this.unclickedNumberButton = this.props.data.unclickedNumberButton
        this.enableAutoplayStartButtonX = -1
        this.enableAutoplayStartButtonY = -63
        this.disableAutoplayStartButtonX = -1
        this.disableAutoplayStartButtonY = -1
    }

    reset() {
        this.props.setValueOfNumberButton(0)
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: "",
                enableOk: false,

            }
        })
    }

    onClick(name: any, value: any) {
        this.props.setValueOfNumberButton(value)
        this.props.interactivityOfStartButton(true)
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedautoplayCount: value,
                buttonSelected: name,
                enableOk: true,
            }
        })
    }


    updateDimensions = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    onMouseClick = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.resetAutoplay && nextProps.resetAutoplay != this.props.resetAutoplay) {
            this.reset();
            // return false;
        }

        if (nextProps.inAutoplay !== this.props.inAutoplay) {
            this.reset();
            // return false
        }
        return true;
    }

    toggleController = (e: any) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                toggleOn: !this.state.toggleOn
            }
        })
    }

    mobileViewAutoplay() {
        const {
            enableOk, selectedautoplayCount
        } = this.state;
        let startButtonX, startButtonY;
        if (enableOk) {
            startButtonX = this.enableAutoplayStartButtonX
            startButtonY = this.enableAutoplayStartButtonY
        } else {
            startButtonX = this.disableAutoplayStartButtonX
            startButtonY = this.disableAutoplayStartButtonY
        }
        return (
            <MDBTable height={"300px"}>
                <MDBTableBody>
                    <tr>
                        <td colSpan={4} style={{border: "none"}}>
                            <MDBContainer style={{padding: '0px', margin: '0px'}}>
                                <MDBRow center={true}>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b1" ? "green" : "grey"} name={"b1"}
                                                onClick={() => this.onClick("b1", 5)}>
                                            {this.props.langObj["autoplayText_9"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b2" ? "green" : "grey"} name={"b2"}
                                                onClick={() => this.onClick("b2", 10)}>
                                            {this.props.langObj["autoplayText_10"]}
                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b3" ? "green" : "grey"} name={"b3"}
                                                onClick={() => this.onClick("b3", 15)}>
                                            {this.props.langObj["autoplayText_11"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b4" ? "green" : "grey"} name={"b4"}
                                                onClick={() => this.onClick("b4", 20)}>
                                            {this.props.langObj["autoplayText_12"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b5" ? "green" : "grey"} name={"b5"}
                                                onClick={() => this.onClick("b5", 30)}>
                                            {this.props.langObj["autoplayText_13"]}

                                        </MDBBtn>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow center={true} style={{marginTop: '10px'}}>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b6" ? "green" : "grey"} name={"b6"}
                                                onClick={() => this.onClick("b6", 40)}>
                                            {this.props.langObj["autoplayText_14"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b7" ? "green" : "grey"} name={"b7"}
                                                onClick={() => this.onClick("b7", 50)}>
                                            {this.props.langObj["autoplayText_15"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b8" ? "green" : "grey"} name={"b8"}
                                                onClick={() => this.onClick("b8", 75)}>
                                            {this.props.langObj["autoplayText_16"]}

                                        </MDBBtn>
                                    </MDBCol>
                                    <MDBCol size="3" sm="3" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor, border: 'none', width: '20%',
                                        maxWidth: '20%', padding: '0px'
                                    }}>
                                        <MDBBtn style={{width: '50px', height: '50px', padding: '0px', margin: '0px'}}
                                                color={this.state.buttonSelected == "b9" ? "green" : "grey"} name={"b9"}
                                                onClick={() => this.onClick("b9", 100)}>
                                            {this.props.langObj["autoplayText_17"]}

                                        </MDBBtn>
                                    </MDBCol>

                                </MDBRow>
                            </MDBContainer>
                        </td>

                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol xs="12"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '15px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_2"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow>
                                    <MDBCol size="5" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <Toggle defaultChecked={true} onChange={() => {
                                           
                                        }}/>
                                    </MDBCol>

                                    <MDBCol size="7" sm="4"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '15px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_3"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{borderTop: "1px solid" + this.partitioningLineBorderColor}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '12px',
                                            paddingTop: '0px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_6"]}</h2>
                                        <input type="range" className="custom-range " id="customRange1"
                                               defaultValue={"60"}/>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '23px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_18"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '12px',
                                            paddingTop: '0px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_7"]}</h2>
                                        <input type="range" className="custom-range " id="customRange2"
                                               defaultValue={"0"}/>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '23px',
                                            fontWeight: 'bold'
                                        }}>0.00</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{border: "none"}}>
                            <MDBContainer>
                                <MDBRow>
                                    <MDBCol size="8" sm="8"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '12px',
                                            paddingTop: '0px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_8"]}</h2>
                                        <input type="range" className="custom-range " id="customRange3"
                                               defaultValue={"0"}/>
                                    </MDBCol>

                                    <MDBCol size="3" sm="3"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '23px',
                                            fontWeight: 'bold'
                                        }}>{this.props.langObj["autoplayText_18"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>

                <MDBTableBody style={{border: "none"}}>
                    <tr>
                        <td style={{borderTop: "1px solid" + this.partitioningLineBorderColor}}>
                            {!this.showFixedPanelPage && <Button variant="danger" onClick={() => {
                                this.props.setAllButtonEnable();
                                this.props.hideAutoplay();
                                this.reset();
                            }}>{this.props.langObj["autoplayText_21"]}</Button>}

                            <button ref={i => this.startbutton = i} className="mobViewButtons" style={{

                                width: '260px',
                                height: '60px',
                                backgroundPositionX: startButtonX,
                                backgroundPositionY: startButtonY,

                                border: 'none'
                            }} disabled={!enableOk}
                                    onClick={() => {
                                        this.props.hideAutoplay();
                                        this.props.setAutoplay(selectedautoplayCount);
                                        this.props.setApplicationAutoplayCount(selectedautoplayCount);
                                        this.props.startAutoplay();

                                        this.props.getApplicationSpinResponse();

                                        this.props.setAllButtonDisable();

                                        this.reset();
                                    }}
                            ><span style={{
                                color: 'white',
                                fontSize: '20px'
                            }}>{this.props.langObj["autoplayText_22"]}</span></button>
                        </td>
                    </tr>
                </MDBTableBody>
            </MDBTable>
        )
    }

    desktopViewAutoplay() {

        const {
            enableOk, selectedautoplayCount, toggleOn
        } = this.state;
        let toggleButtonImage;

        if (toggleOn) {
            toggleButtonImage = this.props.data.toggleButtonOnImage
        } else {
            toggleButtonImage = this.props.data.toggleButtonOffImage
        }

        return (

            <MDBTable style={{
                marginLeft: '0%',
                position: 'absolute',
                top: '60px',
                transform: 'scale(' + this.props.scaleY + ')',
                transformOrigin: 'top'
            }}>
                <MDBTableBody>
                    <tr>
                        <td style={{border: 'none'}}>
                            <MDBContainer style={{pointerEvents: 'auto'}}>
                                <MDBRow style={{border: 'none', height: '70px'}}>
                                    <MDBCol size="12" sm="12"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <h2 style={{
                                            position: 'relative',
                                            bottom: '30%',
                                            color: this.textColor,
                                            fontSize: '42px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                        }}>{this.props.langObj["autoplayText_5"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow center={true}
                                        style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b1", 5)}>
                                        <img
                                            src={this.state.buttonSelected == "b1" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{cursor: 'pointer', width: '124px', height: '66px'}}></img>
                                        <h2 style={{
                                            cursor: 'pointer',
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '50px'
                                        }}>{this.props.langObj["autoplayText_9"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b2", 10)}>
                                        <img
                                            src={this.state.buttonSelected == "b2" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_10"]}</h2>

                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b3", 15)}>
                                        <img
                                            src={this.state.buttonSelected == "b3" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_11"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b4", 20)}>
                                        <img
                                            src={this.state.buttonSelected == "b4" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_12"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b5", 30)}>
                                        <img
                                            src={this.state.buttonSelected == "b5" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_13"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b6", 40)}>
                                        <img
                                            src={this.state.buttonSelected == "b6" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_14"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b7", 50)}>
                                        <img
                                            src={this.state.buttonSelected == "b7" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_15"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b8", 75)}>
                                        <img
                                            src={this.state.buttonSelected == "b8" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '42px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_16"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="1" lg="1" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        width: '10%',
                                        maxWidth: '10%',
                                        padding: '0px',
                                        height: '90px'
                                    }} onClick={() => this.onClick("b9", 100)}>
                                        <img
                                            src={this.state.buttonSelected == "b9" ? this.clickedNumberButton : this.unclickedNumberButton}
                                            style={{width: '124px', height: '66px', cursor: 'pointer'}}></img>
                                        <h2 style={{
                                            fontSize: '38px',
                                            color: '#c0cfbd',
                                            position: "relative",
                                            bottom: "54px",
                                            fontWeight: 'bold',
                                            left: '32px',
                                            cursor: 'pointer'
                                        }}>{this.props.langObj["autoplayText_17"]}</h2>
                                    </MDBCol>


                                </MDBRow>
                                <MDBRow style={{border: 'none', position: 'relative', left: '6%'}}>
                                    <MDBCol sm="12" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        height: '40px'
                                    }}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '28px'
                                        }}>{this.props.langObj["autoplayText_2"]}</h2>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow style={{
                                    backgroundColor: this.mainContainerBgColor,
                                    border: 'none',
                                    position: 'relative',
                                    left: '12%'
                                }}>
                                    <MDBCol size="2" sm="2" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        height: '70px'
                                    }}>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            marginTop: '8px'
                                        }}>{this.props.langObj["autoplayText_3"]}</h2>
                                    </MDBCol>
                                    <MDBCol size="2" sm="2"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <img src={toggleButtonImage} onClick={this.toggleController}
                                             style={{cursor: 'pointer'}}/>
                                    </MDBCol>
                                </MDBRow>

                                <MDBRow style={{
                                    backgroundColor: this.mainContainerBgColor,
                                    border: 'none',
                                    position: 'relative',
                                    left: '12%'
                                }}>
                                    <MDBCol size="6" sm="6"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <input type="range" className="custom-range " id="customRange1"
                                               defaultValue={"60"}/>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            paddingTop: '0px',
                                            textAlign: "left"
                                        }}>{this.props.langObj["autoplayText_6"]}</h2>
                                    </MDBCol>

                                    <MDBCol size="5" sm="5" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        position: 'relative',
                                        bottom: '6px'
                                    }}>
                                        <img src={this.props.data.meterImage}
                                             style={{width: '251px', height: '67px'}}></img>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            fontWeight: 'bold',
                                            position: 'relative',
                                            bottom: '48px',
                                            left: '100px'
                                        }}>{this.props.langObj["autoplayText_18"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{
                                    backgroundColor: this.mainContainerBgColor,
                                    border: 'none',
                                    position: 'relative',
                                    left: '12%'
                                }}>
                                    <MDBCol size="6" sm="6"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <input type="range" className="custom-range " id="customRange2"
                                               defaultValue={"0"}/>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            paddingTop: '0px',
                                            textAlign: "left"
                                        }}>{this.props.langObj["autoplayText_7"]}</h2>
                                    </MDBCol>

                                    <MDBCol size="5" sm="5" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        position: 'relative',
                                        bottom: '6px'
                                    }}>
                                        <img src={this.props.data.meterImage}
                                             style={{width: '251px', height: '67px'}}></img>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            fontWeight: 'bold',
                                            position: 'relative',
                                            bottom: '48px',
                                            left: '90px'
                                        }}>{this.props.langObj["autoplayText_19"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow style={{
                                    backgroundColor: this.mainContainerBgColor,
                                    border: 'none',
                                    position: 'relative',
                                    left: '12%'
                                }}>
                                    <MDBCol size="6" sm="6"
                                            style={{backgroundColor: this.mainContainerBgColor, border: 'none'}}>
                                        <input type="range" className="custom-range " id="customRange3"
                                               defaultValue={"0"}/>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            paddingTop: '0px',
                                            textAlign: "left"
                                        }}>{this.props.langObj["autoplayText_8"]}</h2>
                                    </MDBCol>

                                    <MDBCol size="5" sm="5" style={{
                                        backgroundColor: this.mainContainerBgColor,
                                        border: 'none',
                                        position: 'relative',
                                        bottom: '6px'
                                    }}>
                                        <img src={this.props.data.meterImage}
                                             style={{width: '251px', height: '67px'}}></img>
                                        <h2 style={{
                                            color: this.textColor,
                                            fontSize: '26px',
                                            fontWeight: 'bold',
                                            position: 'relative',
                                            bottom: '48px',
                                            left: '100px'
                                        }}>{this.props.langObj["autoplayText_17"]}</h2>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </td>
                    </tr>
                </MDBTableBody>
            </MDBTable>
        )
    }


    render() {
        if (!this.props.showAutoplay) {
            return (<></>)
        }

        if (isMobile) {
            this.showFixedPanelPage = true
        }

        return (
            <div>
                {!this.showFixedPanelPage && <div>
                    {this.desktopViewAutoplay()}
                </div>}
                {this.showFixedPanelPage && <div>
                    {this.mobileViewAutoplay()}
                </div>}
            </div>
        )
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'autoplayState' | 'applicationState' | 'basegameState'>): IStateToProps =>
        ({
            showAutoplay: state.autoplayState.showAutoplay,
            autoplayStopped: state.autoplayState.autoplayStopped,
            scaleY: state.applicationState.scaleY,
            resetAutoplay: state.autoplayState.resetAutoplay,
            numberButtonValue: state.autoplayState.numberButtonValue,
            inAutoplay: state.basegameState.inAutoplay,

            // currentBetIndex: state.basegameState.currentBetIndex,
            // autoplayCount: state.basegameState.autoplayCount,
            // betList: state.basegameState.betList
        }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        hideAutoplay: (): any => dispatch(autoplayActions.hideAutoplayUI()),
        setAutoplay: (autoplayCount: number): any => dispatch(autoplayActions.setAutoplayCount(autoplayCount)),
        startAutoplay: (): any => dispatch(baseGameActions.startAutoplay()),
        setApplicationAutoplayCount: (autoplaycount: number): any => dispatch(baseGameActions.setApplicationAutoplayCount(autoplaycount)),
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        stoppedAutoplayUI: (autoplayStopped: boolean): any => dispatch(autoplayActions.stoppedAutoplayUI(autoplayStopped)),
        setValueOfNumberButton: (numberButtonValue: number): any => dispatch(autoplayActions.setValueOfNumberButton(numberButtonValue)),
        interactivityOfStartButton: (startButtonInteractivity: boolean): any => dispatch(autoplayActions.interactivityOfStartButton(startButtonInteractivity)),
    }))(withAutoplayConfiguration(Autoplay)));